/**
 * Overe event tracking. One call, every destination.
 *
 *   overeTrack('quiz_lead', { energy_state: 'Open' }, true)
 *
 * sends a GA4 event through the gtag the Google channel app leaves on the
 * page (config G-3Q5FZSGRH8, send_page_view false, so page views stay the
 * app's job), a Meta custom event of the same name through the Facebook
 * channel's fbq, plus a standard Meta `Lead` when the third argument is true
 * (that is what the ads optimise on), and a Shopify custom pixel event so a
 * custom pixel can pick it up later. Every destination is guarded: a blocked
 * or missing tag never throws into the form that called it.
 *
 * The third argument is `true` for a Meta `Lead`, or the name of another
 * standard Meta event to fire alongside ('ViewContent', 'InitiateCheckout').
 *
 * Names are GA4 style, snake_case verbs: quiz_started, quiz_completed,
 * quiz_lead, quiz_skipped, waitlist_joined, guide_requested,
 * contact_submitted, ebook_viewed, membership_viewed, cta_click, and the
 * booking_* set in overe-booking.
 *
 * Two things fire on their own from here, so the funnel audiences in Meta
 * and GA4 do not depend on every section remembering to call in:
 *   - a page on the `guide` or `membership` template sends `ebook_viewed` or
 *     `membership_viewed` (with Meta ViewContent) on load
 *   - every `.btn` click sends `cta_click` with the button's text and href, so
 *     "clicked Get the ebook but did not buy" and "clicked Claim a founding
 *     place but did not join" are buildable audiences
 */
(function () {
  'use strict';

  window.overeTrack = function (name, params, standard) {
    params = params || {};
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
    } catch (e) {}
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', name, params);
        if (standard === true) window.fbq('track', 'Lead', params);
        else if (typeof standard === 'string' && standard) window.fbq('track', standard, params);
      }
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, params);
      }
    } catch (e) {}
  };

  var VIEWS = { guide: 'ebook_viewed', membership: 'membership_viewed' };

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* the channel apps inject gtag and fbq after the page is parsed, so a view
     event sent at DOMContentLoaded can land before either exists and be
     dropped by the guards. Poll for both (15s ceiling), then send once. */
  function whenTagsReady(fn) {
    var tries = 0;
    (function poll() {
      var ready = typeof window.gtag === 'function' && typeof window.fbq === 'function';
      if (ready || tries++ > 60) return fn();
      setTimeout(poll, 250);
    })();
  }

  onReady(function () {
    var suffix = document.body.getAttribute('data-template') || '';
    if (VIEWS[suffix]) {
      whenTagsReady(function () {
        window.overeTrack(VIEWS[suffix], { content_name: suffix === 'guide' ? 'ebook' : suffix, content_type: 'product' }, 'ViewContent');
      });
    }

    document.addEventListener('click', function (event) {
      var el = event.target && event.target.closest ? event.target.closest('a.btn, button.btn, .btn') : null;
      if (!el) return;
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80);
      var href = el.getAttribute('href') || '';
      window.overeTrack('cta_click', {
        cta_text: text,
        cta_href: href,
        page_template: suffix,
        page_path: window.location.pathname
      });
    }, true);
  });

  /* Klaviyo's own onsite forms (the Book page's Jemma waitlist card opens one
     with klaviyo.openForm) never pass through our code, so their submissions
     are picked up from the event the onsite script dispatches on window. */
  window.addEventListener('klaviyoForms', function (event) {
    var d = event && event.detail;
    if (!d || d.type !== 'submit') return;
    window.overeTrack('klaviyo_form_submitted', {
      form_id: d.formId || '',
      form_name: d.formTitle || '',
      page_path: window.location.pathname
    }, true);
  });
})();
